import React, { useEffect, useState } from "react";
import PageHeading from "../../components/PageHeading";
import { BackButton } from "../../components/btn/Buttons";
import Button from "../../components/btn/Button";
import Input from "../../components/inputs/Input";
import { useSelector } from "react-redux";
import moment from "moment";

import store from "../../redux/store";
import { get_day_end_data, get_dayend_data } from "./DayendDaySlice";
import PageLoading from "../../components/PageLoading";

import Loader from "../../components/Loader";
import Table from "../../components/table/Table";

import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";

const DayEnd = () => {
  const [date, setDate] = useState("");
  const [show, setShow] = useState(false);

  const { dayend_list, day_end_list, dayend_loading, day_end_loading } =
    useSelector((state) => state.day_end);
  const { firm_name } = useSelector((state) => state.profile);

  const handle_load_data = () => {
    store.dispatch(get_day_end_data({ date: date, page: 1, limit: 10 }));
  };
  console.log("day_end_list", day_end_list?.last_verified_date);
  useEffect(() => {
    store.dispatch(get_day_end_data());
  }, []);
  const verified_date = day_end_list?.last_verified_date?.split("T")[0] || "";
  const formatToYYYYMMDD = (dateStr) => {
    if (!dateStr) return "";

    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  };

  const verified_date1 = formatToYYYYMMDD(verified_date);
  console.log("verified_date1", verified_date1);
  return (
    <div className="container">
      <PageHeading
        title={"Day End"}
        right={
          <>
            <BackButton />
          </>
        }
      />
      <div style={{ height: "20px" }}></div>

      <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
        <Input
          mw={"150px"}
          type={"date"}
          min={verified_date1}
          value={date}
          disabled={day_end_loading}
          // onChange={(e) => {
          //   setDate(e.target.value);
          // }}
          onChange={(e) => {
            const selectedDate = e.target.value;
            if (verified_date1 && selectedDate < verified_date1) {
              alert(`Date cannot be before ${verified_date1}`);
              return;
            }

            setDate(selectedDate);
          }}
        />

        <Button
          title={"SEARCH"}
          onClick={() => {
            handle_load_data();
            setShow(true);
          }}
        />
      </div>

      {day_end_loading ? (
        <PageLoading />
      ) : (
        day_end_list?.message && (
          <div className="container card mt20">
            <p>{day_end_list?.message}</p>
          </div>
        )
      )}
      {day_end_loading && !show && (
        <Loader loading={day_end_loading && !show} />
      )}
    </div>
  );
};

export default DayEnd;
